<template>
  <div :class="bem()">
    <swiper-container
      :class="bem('swiper')"
      :loop="true"
      :autoplay-delay="3000"
      :pagination="{
        clickable: true,
      }"
    >
      <swiper-slide :class="bem('slide')" v-for="(item, index) in carouselList" :key="index">
        <div :class="bem('item')">
          <img
            :class="bem('')"
            :src="item.img"
            alt="" />
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script>
import { getHomeData } from '@/api/home/carousel'
export default {
  name: 'carousel-view',
  components: {
  },
  data() {
    return {
      carouselList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 100,
      }
    }
  },
  methods: {
    async initData() {
      try {
        const res = await getHomeData(this.queryParams);
        if (res.code == 0) {
          this.carouselList = res.data.list;
        }
      } catch(err) {
        console.log('err', err)
      }
    },
  },
  mounted() {
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.carousel-view {
  width: 100%;
  height: 650px;
  @include devices(laptop) {
    height: 600px;
  }
  @include devices(pad) {
    height: 450px;
  }
  @include devices(phone) {
    height: 300px;
  }
  &__swiper {
    width: 100%;
    height: 100%;
  }
  &__slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
